module.exports = __webpack_public_path__ + "img/icon4.3c4c9865.png";